import { Content, NavParams, NavController, Events, ToastController, Platform } from 'ionic-angular';
import { ViewChild, Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl, AbstractControl } from '@angular/forms';

import { UserService } from '../../services/user.service';
import { AuthenticateService } from '../../services/authenticateService';
import { LocalStorageService } from '../../services/local-storage';
import { AlertMessager } from '../../lib/alertMessager';
import { EventNames } from '../../lib/eventNames';
import { LoadingController } from 'ionic-angular';
import { AccountHelper } from '../../lib/accountHelper';

import { RodeosPage } from '../rodeo/rodeos';

@Component({
    selector: 'page-signup',
    templateUrl: 'signup.html'
})
export class SignUpPage {
    @ViewChild(Content) content: Content;

    viewMode: string = 'login';

    emailAddress: string = '';
    password: string = '';
    confirmPassword: string = '';

    signupForm: FormGroup;
    submitAttempt: boolean;
    validationMessages: any;

    passwordType: string = 'password';
    passwordIconType: string = 'eye';

    loggingIn: boolean;

    constructor(public nav: NavController, private authenticateService: AuthenticateService, private userService: UserService, private platform: Platform,
                private events: Events, private navParams: NavParams, private alertMessager: AlertMessager, private loadingControl: LoadingController,
                private localStorage: LocalStorageService, private formBuilder: FormBuilder, private toast: ToastController) {
            this.signupForm = this.formBuilder.group({
                email: new FormControl('email', Validators.compose([
                    Validators.required,
                    Validators.pattern('^[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')
                ])),
                password: new FormControl('password',  Validators.required),
                confirm: new FormControl('confirm',  this.checkPasswords),
            });

            if (this.navParams.get('viewMode') != undefined)
                this.viewMode = this.navParams.get('viewMode');
                
            this.validationMessages = [
                { name: 'email', type: 'required', message: 'Email Address is required.' },
                { name: 'email', type: 'pattern', message: 'Your email address has an incorrect format.' },
                { name: 'password', type: 'required', message: 'Password is required.' },
                { name: 'confirm', type: 'checkPasswords', message: 'Passwords do not match.' },
            ];
    }

    checkPasswords(control: AbstractControl) {
        if (!control || !control.parent) {
            return null;
        }

        const password = control.parent.get('password');
        const confirmPass = control.parent.get('confirm');

        if (password == null || confirmPass == null) {
            return null;
        }

        return password.value === confirmPass.value && confirmPass.value != null && confirmPass.value != '' ? null : { checkPasswords: true};
    }
    
    showHide() {
        if (this.passwordType == 'text') {
            this.passwordType = 'password';
            this.passwordIconType = 'eye';
        }
        else {
            this.passwordType = 'text';
            this.passwordIconType = 'eye-off';
        }
    }

	signIn() {
        this.nav.pop();
	}

    signUp() {
        if (this.loggingIn)
            return;

        this.loggingIn = true;
        this.submitAttempt = true;
        console.log("signupForm: ", this.signupForm);

        if (this.signupForm.valid) {
            let loading = this.loadingControl.create({
                content: 'Creating Account...',
            });

            loading.present();
            this.userService.addUser({ emailAddress: this.emailAddress, password: this.password }).then(data => {
                this.loggingIn = false;
                loading.dismiss();

                if ((data as any).errorMessage !== undefined) {
                    this.alertMessager.showError('Account Signup Failed', (data as any).errorMessage);
                } else {
                    this.events.publish(EventNames.roperCreated, data);
                    this.authenticateService.authenticate(this.emailAddress, this.password)
                        .then(data => {
                            let toast = this.toast.create({
                                message: 'Successfully created account.',
                                duration: 3000,
                            });
                            toast.present();
                            this.localStorage.updateEntity('authtokens', data).then(data => {
                                this.events.publish(EventNames.userLoggedIn);
                                AccountHelper.instance().loadToken(data);
                                this.userService.getUser(data.id);
            
                                this.nav.setRoot(RodeosPage);
                            });
                        });
                }
            }, error => { 
                this.loggingIn = false;
                loading.dismiss(); 
                this.alertMessager.showError('Account Signup Failed', error); 
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/signup.ts